import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfSouthernCalifornia = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Southern California"
      universityShortName="USC"
      slug="university-of-southern-california"
      seoTitle="USC Study Rooms | Norris Library and Campus Study Spaces"
      seoDescription="Find study rooms at USC including Norris Medical Library and Mudd Hall. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="USC study rooms, Norris Medical Library, USC library, Los Angeles study spaces, Trojan study rooms"
      canonicalUrl="/study-room/university-of-southern-california/"
      heroDescription="Discover USC's diverse study spaces from the Hogwarts-like Mudd Hall to modern Annenberg."
      libraryWebsiteUrl="https://libraries.usc.edu"
      libraryWebsiteName="USC Libraries"
      studySpaces={[
        {
          name: "Norris Medical Library - Group Rooms",
          features: "Priority for groups of 4-10, then 2-3, then individuals. 2 hours/day max, book 1 day ahead.",
          feedback: "Current students only. Strict policies enforced."
        },
        {
          name: "Mudd Hall Library of Philosophy",
          features: "Hogwarts-like atmosphere, long tables, heavy chairs.",
          feedback: "Perfect for writing papers in quiet environment. Beautiful historic space."
        },
        {
          name: "New Annenberg Lobby",
          features: "Tables, chairs, whiteboards on all 5 floors. Louder environment.",
          feedback: "Great for those who like background noise. Very social."
        },
        {
          name: "Leavey Library - Basement",
          features: "Individual quiet study spaces, 24-hour access during finals.",
          feedback: "Good for individual focused work. Can get crowded during exams."
        }
      ]}
      guideContent={
        <>
          <p>
            USC's Norris Medical Library group study rooms are reserved only for current USC students for academic purposes. 
            Priority is given to groups of 4-10, followed by groups of 2-3; individuals are last.
          </p>
          <p className="mt-4">
            Reservations must be at least one hour, may be made no more than one day in advance, are limited to two hours 
            per day per group, and expire after 15 minutes. Smoking, food and loud noise are prohibited.
          </p>
          <p className="mt-4">
            Reserve Norris rooms for serious group study, but for individual quiet time head to the Philosophy Library 
            (Mudd Hall) with its Hogwarts-like atmosphere or the basement of Leavey Library. If you need a more social 
            environment, try the New Annenberg lobby or Fertitta Hall's open seating.
          </p>
        </>
      }
      summaryTips={[
        "Book Norris rooms only 1 day in advance",
        "Groups of 4-10 get priority for rooms",
        "Mudd Hall Philosophy Library is Hogwarts-like",
        "Annenberg lobby is social and lively",
        "15-minute check-in required or room expires"
      ]}
    />
  );
};

export default UniversityOfSouthernCalifornia;
